import script from "./ConfiguratorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguratorView.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguratorView.vue?vue&type=style&index=0&id=fc4ae3fe&scoped=true&lang=css"
import "./ConfiguratorView.vue?vue&type=style&index=1&id=fc4ae3fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4ae3fe"]])

export default __exports__